// 翻譯模塊統一導出
import { oauth as oauthEn } from './oauth_en.js';
import { oauth as oauthTc } from './oauth_tc.js';
import { oauth as oauthSc } from './oauth_sc.js';
import { common as commonEn } from './common_en.js';
import { common as commonTc } from './common_tc.js';
import { common as commonSc } from './common_sc.js';
import { credits as creditsEn } from './credits_en.js';
import { credits as creditsTc } from './credits_tc.js';
import { credits as creditsSc } from './credits_sc.js';
import { invites as invitesEn } from './invites_en.js';
import { invites as invitesTc } from './invites_tc.js';
import { invites as invitesSc } from './invites_sc.js';
import { orders as ordersEn } from './orders_en.js';
import { orders as ordersTc } from './orders_tc.js';
import { orders as ordersSc } from './orders_sc.js';
import { profile as profileEn } from './profile_en.js';
import { profile as profileTc } from './profile_tc.js';
import { profile as profileSc } from './profile_sc.js';
import { navbar as navbarEn } from './navbar_en.js';
import { navbar as navbarTc } from './navbar_tc.js';
import { navbar as navbarSc } from './navbar_sc.js';
import { login as loginEn } from './login_en.js';
import { login as loginTc } from './login_tc.js';
import { login as loginSc } from './login_sc.js';
import { showcase as showcaseEn } from './showcase_en.js';
import { showcase as showcaseTc } from './showcase_tc.js';
import { showcase as showcaseSc } from './showcase_sc.js';
import { catoo as catooEn } from './catoo_en.js';
import { catoo as catooTc } from './catoo_tc.js';
import { catoo as catooSc } from './catoo_sc.js';
import { personalCenter as personalCenterEn } from './personalCenter_en.js';
import { personalCenter as personalCenterTc } from './personalCenter_tc.js';
import { personalCenter as personalCenterSc } from './personalCenter_sc.js';
import { creationRecord as creationRecordEn } from './creationRecord_en.js';
import { creationRecord as creationRecordTc } from './creationRecord_tc.js';
import { creationRecord as creationRecordSc } from './creationRecord_sc.js';
import { pricing as pricingEn } from './pricing_en.js';
import { pricing as pricingTc } from './pricing_tc.js';
import { pricing as pricingSc } from './pricing_sc.js';
import { imageUpscaler as imageUpscalerEn } from './imageUpscaler_en.js';
import { imageUpscaler as imageUpscalerTc } from './imageUpscaler_tc.js';
import { imageUpscaler as imageUpscalerSc } from './imageUpscaler_sc.js';
import { aiWorkbench } from './aiworkbench/index.js';
import { paymentMethod as paymentMethodEn } from './paymentMethod_en.js';
import { paymentMethod as paymentMethodTc } from './paymentMethod_tc.js';
import { paymentMethod as paymentMethodSc } from './paymentMethod_sc.js';
import { payment as paymentEn } from './payment_en.js';
import { payment as paymentTc } from './payment_tc.js';
import { payment as paymentSc } from './payment_sc.js';
import { refund as refundEn } from './refund_en.js';
import { refund as refundTc } from './refund_tc.js';
import { refund as refundSc } from './refund_sc.js';
import { aiToolTemplate as aiToolTemplateEn } from './aiToolTemplate_en.js';
import { aiToolTemplate as aiToolTemplateTc } from './aiToolTemplate_tc.js';
import { aiToolTemplate as aiToolTemplateSc } from './aiToolTemplate_sc.js';
import { imageService as imageServiceEn } from './imageService_en.js';
import { imageService as imageServiceTc } from './imageService_tc.js';
import { imageService as imageServiceSc } from './imageService_sc.js';
import { logoGeneration as logoGenerationTc } from './logoGeneration_tc.js';
import { logoGeneration as logoGenerationSc } from './logoGeneration_sc.js';
import { logoGeneration as logoGenerationEn } from './logoGeneration_en.js';
import { idPhotoGeneration as idPhotoGenerationEn } from './idPhotoGeneration_en.js';
import { idPhotoGeneration as idPhotoGenerationTc } from './idPhotoGeneration_tc.js';
import { idPhotoGeneration as idPhotoGenerationSc } from './idPhotoGeneration_sc.js';
import { polling as pollingEn } from './polling_en.js';
import { polling as pollingTc } from './polling_tc.js';
import { polling as pollingSc } from './polling_sc.js';
import { unifiedError as unifiedErrorTc } from './unifiedError_tc.js';
import { unifiedError as unifiedErrorEn } from './unifiedError_en.js';
import { unifiedError as unifiedErrorSc } from './unifiedError_sc.js';
import { errorHandler as errorHandlerEn } from './errorHandler_en.js';
import { errorHandler as errorHandlerTc } from './errorHandler_tc.js';
import { errorHandler as errorHandlerSc } from './errorHandler_sc.js';
import { videoGeneration } from './videoGeneration/index.js';
import { shareView as shareViewEn } from './shareView_en.js';
import { shareView as shareViewTc } from './shareView_tc.js';
import { shareView as shareViewSc } from './shareView_sc.js';

const oauth = {
  'en': oauthEn,
  'zh': oauthSc,

  'zh-TW': oauthTc,
};
const common = {
  'en': commonEn,
  'zh': commonSc,

  'zh-TW': commonTc,
};
const credits = {
  'en': creditsEn,
  'zh': creditsSc,

  'zh-TW': creditsTc,
};
const invites = {
  'en': invitesEn,
  'zh': invitesSc,

  'zh-TW': invitesTc,
};
const orders = {
  'en': ordersEn,
  'zh': ordersSc,

  'zh-TW': ordersTc,
};
const profile = {
  'en': profileEn,
  'zh': profileSc,

  'zh-TW': profileTc,
};
const navbar = {
  'en': navbarEn,
  'zh': navbarSc,

  'zh-TW': navbarTc,
};
const login = {
  'en': loginEn,
  'zh': loginSc,

  'zh-TW': loginTc,
};
const showcase = {
  'en': showcaseEn,
  'zh': showcaseSc,

  'zh-TW': showcaseTc,
};
const catoo = {
  'en': catooEn,
  'zh': catooSc,

  'zh-TW': catooTc,
};
const personalCenter = {
  'en': personalCenterEn,
  'zh': personalCenterSc,

  'zh-TW': personalCenterTc,
};
const creationRecord = {
  'en': creationRecordEn,
  'zh': creationRecordSc,

  'zh-TW': creationRecordTc,
};
const pricing = {
  'en': pricingEn,
  'zh': pricingSc,

  'zh-TW': pricingTc,
};
const imageUpscaler = {
  'en': imageUpscalerEn,
  'zh': imageUpscalerSc,

  'zh-TW': imageUpscalerTc,
};
const paymentMethod = {
  'en': paymentMethodEn,
  'zh': paymentMethodSc,

  'zh-TW': paymentMethodTc,
};
const payment = {
  'en': paymentEn,
  'zh': paymentSc,

  'zh-TW': paymentTc,
};
const refund = {
  'en': refundEn,
  'zh': refundSc,

  'zh-TW': refundTc,
};
const aiToolTemplate = {
  'en': aiToolTemplateEn,
  'zh': aiToolTemplateSc,

  'zh-TW': aiToolTemplateTc,
};
const imageService = {
  'en': imageServiceEn,
  'zh': imageServiceSc,

  'zh-TW': imageServiceTc,
};
const logoGeneration = {
  'en': logoGenerationEn,
  'zh': logoGenerationSc,

  'zh-TW': logoGenerationTc,
};
const idPhotoGeneration = {
  'en': idPhotoGenerationEn,
  'zh': idPhotoGenerationSc,

  'zh-TW': idPhotoGenerationTc,
};
const polling = {
  'en': pollingEn,
  'zh': pollingSc,

  'zh-TW': pollingTc,
};
const unifiedErrorHandler = {
  'en': unifiedErrorEn,
  'zh': unifiedErrorSc,
  'zh-TW': unifiedErrorTc,
};
const errorHandler = {
  'en': errorHandlerEn,
  'zh': errorHandlerSc,
  'zh-TW': errorHandlerTc,
};
const shareView = {
  'en': shareViewEn,
  'zh': shareViewSc,

  'zh-TW': shareViewTc,
};


// 合併所有翻譯模塊
export const translations = {
  oauth,
  common,
  credits,
  invites,
  orders,
  profile,
  navbar,
  login,
  showcase,
  catoo,
  personalCenter,
  creationRecord,
  pricing,
  imageUpscaler,
  aiWorkbench,
  paymentMethod,
  payment,
  refund,
  aiToolTemplate,
  imageService,
  logoGeneration,
  idPhotoGeneration,
  polling,
  unifiedErrorHandler,
  errorHandler,
  videoGeneration,
  shareView
};

// 翻譯函數
export const getTranslation = (key, language = 'en', variables = {}) => {
  const keys = key.split('.');
  
  // 第一個key是模塊名稱（如 common, oauth 等）
  const moduleName = keys[0];
  const module = translations[moduleName];
  
  if (!module) {
    return key; // 如果找不到模塊，返回原始key
  }
  
  // 語言回退邏輯：zh-TW 優先，如果沒有則回退到 zh
  let targetLanguage = language;
  if (language === 'zh-TW' && !module[language] && module['zh']) {
    targetLanguage = 'zh';
  }
  // 如果是 zh 語言但模塊有 zh-TW，則優先使用 zh-TW
  if (language === 'zh' && module['zh-TW']) {
    targetLanguage = 'zh-TW';
  }
  
  // 檢查模塊是否有對應的語言
  if (!module[targetLanguage]) {
    return key; // 如果找不到對應語言，返回原始key
  }
  
  // 從第二個key開始，在對應語言的翻譯中查找
  let translation = module[targetLanguage];
  for (let i = 1; i < keys.length; i++) {
    if (translation && translation[keys[i]]) {
      translation = translation[keys[i]];
    } else {
      return key; // 如果找不到翻譯，返回原始key
    }
  }
  
  // 如果找到翻譯且有變量需要替換
  if (translation && typeof translation === 'string' && Object.keys(variables).length > 0) {
    // 替換模板變量，支持 {variableName} 格式
    return translation.replace(/\{(\w+)\}/g, (match, variableName) => {
      return variables[variableName] !== undefined ? variables[variableName] : match;
    });
  }
  
  return translation || key;
};